import { render } from "./pb-formsponsors.vue?vue&type=template&id=6c053435"
import script from "./pb-formsponsors.vue?vue&type=script&lang=js"
export * from "./pb-formsponsors.vue?vue&type=script&lang=js"

import "./pb-formsponsors.vue?vue&type=style&index=0&id=6c053435&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__